import { render } from "./activeToDo.vue?vue&type=template&id=38a721f8&scoped=true"
import script from "./activeToDo.vue?vue&type=script&lang=js"
export * from "./activeToDo.vue?vue&type=script&lang=js"

import "./activeToDo.vue?vue&type=style&index=0&id=38a721f8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a721f8"]])

export default __exports__